// Kırpma bölgesinin (yüzde) merkez noktası — kartlarda object-position için.
export const cropCenter = (crop) =>
  crop && crop.width
    ? `${crop.x + crop.width / 2}% ${crop.y + crop.height / 2}%`
    : "center";

// Hero görselini, seçilen kırpma bölgesi çerçeveyi dolduracak şekilde konumlar.
// Bölge görselin dışına taşarsa (uzaklaştırma) görsel küçülür, koyu çerçeve kalır.
export const heroCropStyle = (crop) => {
  if (crop && crop.width) {
    return {
      position: "absolute",
      width: `${10000 / crop.width}%`,
      height: "auto",
      maxWidth: "none",
      left: `${-(crop.x / crop.width) * 100}%`,
      top: `${-(crop.y / crop.height) * 100}%`,
    };
  }
  return { width: "100%", height: "100%", objectFit: "cover", objectPosition: "center" };
};
